<cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueck-dienstbarkeiten">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.Dienstbarkeiten" | translate }}</h2>
  </ng-container>
  <cap-standardrecht-table [hasRight]="grundstueckEntry?.permissions?.dienstbarkeiten && ersterfassungUebergeben" [listLoader]="loader">
  </cap-standardrecht-table>
</cap-rubrik>
